// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"modal-body_modal_body__LZcJe"};